import { Directive, ElementRef, HostListener, inject, input, Input } from "@angular/core";

@Directive({
  selector: "[commonToggleDetailsRow]",
  standalone: true,
})
export class ToggleDetailsRowDirective {
  /**
     Reference that connects the directive with a details row
   */
  @Input() detailsRow!: HTMLTableRowElement;
  /**
   * Class that will be set after toggle down clicked. By default, it is set to 'fa-angle-down'
   */
  readonly downClass = input<string>("fa-angle-down");
  /**
   * Class that will be set after toggle up clicked. By default, it is set to 'fa-angle-up'
   */
  readonly upClass = input<string>("fa-angle-up");

  readonly #elRef = inject(ElementRef);

  @HostListener("click", ["$event"])
  onDetailsClick() {
    const parentTd = this.#elRef.nativeElement.closest("td");
    if (this.detailsRow.hidden) {
      this.#elRef.nativeElement.classList.remove(this.downClass());
      this.#elRef.nativeElement.classList.add(this.upClass());
      this.detailsRow.hidden = false;
      if (parentTd) {
        parentTd.classList.add("details-cell-open");
      }
    } else {
      this.#elRef.nativeElement.classList.remove(this.upClass());
      this.#elRef.nativeElement.classList.add(this.downClass());
      this.detailsRow.hidden = true;
      if (parentTd) {
        parentTd.classList.remove("details-cell-open");
      }
    }
  }
}
